
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Alert, Container } from 'react-bootstrap'; // Certifique-se de importar os componentes necessários do React Bootstrap
import '../../style/formulario.css'; // Estilos gerais
import api from '../../redux/actions/configApi'
import Loader from '../../components/loading'
import InputMask from 'react-input-mask';
import {formatDateBRV2} from '../../util'

const EditUserIndex = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        rg: '',
        cpf: '',
        cep: '',
        address: '',
        number: '',
        neighborhood: '',
        complement: '',
        telefone: '',
        city: '',
        state: '',
        data_nascimento: '',
        bankAccount: '', // Exemplo de dado bancário
    });

    const [bankDetails, setBankDetails] = useState({
        bank_name: '',
        account_number: '',
        agency_number: '',
        account_holder_name: '',
        cpf_cnpj: ''
    });

    const [errors2, setErrors2] = useState({});
    const [errorMessageUnique, setErrorMessageUnique] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ cpf: '' });

    // Função para lidar com mudanças no formulário
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleBankChange = (e) => {
        const { name, value } = e.target;
        setBankDetails({ ...bankDetails, [name]: value });
    };
    // Função para simular envio do formulário
    const handleSubmit = (event) => {
      // alert('chamaou')
        event.preventDefault();
        setLoading(true);
        setSuccess('')
        setErrorMessageUnique(null);
        setErrors2({});
        console.log(formData, 'formData')
        const data = {
            ...formData,
            //bankDetails,
        };

        const cpfError = validateCpf(formData.cpf);
        if (cpfError) {
            setFormData(prevFormData => ({
                ...prevFormData,       // Mantém todos os outros campos
                cpf: ""                // Atualiza apenas o campo 'cpf'
            }));
            setErrors({ cpf: cpfError });
            setLoading(false);
            return;
        }
        api.post('update-user', data)
            .then((response) => {
                ///alert('opa')
                setSuccess('Dados atualizados com sucesso!');
                setLoading(false);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Faz uma rolagem suave até o topo
                });
            })
            .catch((error) => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Faz uma rolagem suave até o topo
                });
                setLoading(false);
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        setErrors2(error.response.data.errors); // Captura erros de validação
                    } else if (error.response.data.message) {
                        setErrorMessageUnique(error.response.data.message); // Captura erros gerais
                    }
                }
            });
    };
    const validateCpf = (value) => {

        if (value == null) {
            return "CPF obrigatorio";
        }

        const cpfDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cpfDigits.length !== 11) {
            return "CPF inválido. Deve conter 11 dígitos.";
        }
        // Verifica se todos os dígitos são iguais (CPFs inválidos como "111.111.111-11")
        if (/^(\d)\1+$/.test(cpfDigits)) {
            return "CPF inválido. Não pode ter todos os dígitos iguais.";
        }

        // Validação dos dígitos verificadores
        let sum = 0;
        let remainder;

        // Valida o primeiro dígito verificador
        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (11 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[9])) {
            return "CPF inválido.";
        }

        // Valida o segundo dígito verificador
        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (12 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[10])) {
            return "CPF inválido.";
        }

        return ''; // CPF válido
    };
    const handleCpfChange = (e) => {
        const value = e.target.value;
        setFormData(prevFormData => ({
            ...prevFormData,       // Mantém todos os outros campos
            cpf: value               // Atualiza apenas o campo 'cpf'
        }));
        setErrors({ ...errors, cpf: validateCpf(value) });
    };
    const fetchUserData = async () => {
        setLoading(true)
        try {
            const response = await api.get('/user-data');
            const data = response.data;
            console.log(data, 'data.response')
            // Atualizando estados com os dados recebidos
            setFormData({
                name: data.user.name,
                email: data.user.email,
                cpf: data.user.cpf,
                rg: data.user.rg,
                address: data.address.address,
                number: data.address.number,
                neighborhood: data.address.neighborhood,
                city: data.address.city,
                state: data.address.state,
                cep: data.address.cep,
                complement: data.address.complement,
                telefone: data.user.telefone,
                data_nascimento: formatDateBRV2(data.user.data_nascimento),
            });

            //setBankDetails(data.bankDetails);
            setLoading(false)
        } catch (error) {
            console.error("Erro ao buscar dados do usuário: ", error);
            setErrorMessageUnique("Erro ao buscar dados do usuário. Tente novamente mais tarde.");
            setLoading(false)
        }
    };
    useEffect(() => {
        fetchUserData();
    }, []);


    return (
        <Container>
            <div className='edit-user-form'>
                <h2 className="text-center mb-4 titulo-modal titulo-pagina"><i style={{ color: '#ff7a00' }} class="fa-solid fa-user-tie mr-3"></i> Editar dados Usuário</h2>
                {success && (
                    <Alert className="text-center" variant="success">
                        {success}
                        <Button className="m-3" variant="close" onClick={() => setSuccess(null)}></Button>
                    </Alert>
                )}
                {(Object.keys(errors2).length > 0 || errorMessageUnique) && (
                    <Alert variant="danger" className="text-center">
                        {errorMessageUnique && <div>{errorMessageUnique}</div>}
                        {Object.keys(errors2).map((key) => (
                            <div key={key}>{errors2[key]}</div>
                        ))}
                    </Alert>
                )}
                <div className={`loading ${loading ? 'loading-active' : ''}`}>
                    <Loader loading={loading} />
                    <form onSubmit={handleSubmit}>
                        <div className="form-container">
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="fullName">
                                    <Form.Label className="mt-3">Nome Completo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="email">
                                    <Form.Label className="mt-3">Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="rg">
                                    <Form.Label className="mt-3">RG</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="rg"
                                        value={formData.rg}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="birthDate">
                                    <Form.Label className='mt-3'>Data de Nascimento</Form.Label>
                                    <InputMask
                                        mask="99/99/9999" // Formato DD/MM/YYYY
                                        value={formData.data_nascimento}
                                        name="data_nascimento"
                                        onChange={handleChange}
                                        placeholder="DD/MM/AAAA"
                                    >
                                        {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                    </InputMask>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="cpf">
                                    <Form.Label className='mt-3'>CPF</Form.Label>
                                    <InputMask
                                        mask="999.999.999-99"
                                        value={formData.cpf}
                                        onChange={handleCpfChange}
                                        required
                                        name="cpf"
                                    >
                                        {(inputProps) => (
                                            <Form.Control
                                                {...inputProps}
                                                type="text"
                                                placeholder="Digite o CPF"
                                                isInvalid={!!errors.cpf}
                                                required
                                            />
                                        )}
                                    </InputMask>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.cpf}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="celular">
                                    <Form.Label className='mt-3'>Telefone</Form.Label>
                                    <InputMask
                                        mask="(99) 99999-9999" // Máscara para telefone com 9 dígitos no Brasil
                                        value={formData.telefone}
                                        name="telefone"
                                        onChange={handleChange}
                                        placeholder="Número do celular"
                                    >
                                        {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                    </InputMask>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="cep">
                                    <Form.Label className="mt-3">CEP</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="cep"
                                        value={formData.cep}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="address">
                                    <Form.Label className="mt-3">Endereço</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>

                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="number">
                                    <Form.Label className="mt-3">Número</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="number"
                                        value={formData.number}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="number">
                                    <Form.Label className="mt-3">Complemento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="complement"
                                        value={formData.complement}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>

                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="neighborhood">
                                    <Form.Label className="mt-3">Bairro</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="neighborhood"
                                        value={formData.neighborhood}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="city">
                                    <Form.Label className="mt-3">Cidade</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="state">
                                    <Form.Label className="mt-3">Estado</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Row>
                            <div className="text-center">
                                <Button type="submit" className="mt-4" disabled={loading}>
                                    {loading ? 'Enviando...' : 'Salvar Alterações'}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Container>
    );
};

export default EditUserIndex;
